<template>
  <div class="hero">
    <div v-if="showButtons" class="hero-buttons">
      <a href="#sub_id">
        <CustomButton
          class="choose-btn"
          type="prime"
          :class="{ short: true }"
        >
          {{ $t("try_free") }}
        </CustomButton>
      </a>
      <CustomButton
        v-if="false"
        class="choose-btn"
        type="simple"
        :class="{ short: true }"
      >
        <template #icon>
          <TriangleIcon fill="var(--font-color)" rotate="right" />
        </template>
        {{ $t("Watch_video") }}
      </CustomButton>
    </div>

    <div class="pictures wrapper-primery">
      <picture>
        <!-- картинка первого экрана: lazy откладывал её загрузку до вёрстки,
             поэтому она всегда приходила последней -->
        <img
          :src="imgSrc"
          alt="picture"
          width="1770"
          height="978"
          fetchpriority="high"
          decoding="async"
        />
      </picture>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from "vue";
import { useStore } from "vuex";

import TriangleIcon from "../common/icons/Triangle.vue";
import CustomButton from "../common/form/CustomButton.vue";

const props = defineProps({
  isNew: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();

const isDarkTheme = computed(() => store.getters.isDarkTheme);

// user: null — сессия ещё не проверена, false — гость, объект — авторизован
const isSessionChecked = computed(() => store.state.user !== null);

// Кнопка есть только у новых юзеров, но до ответа /v2/auth/init это неизвестно.
// Показать её всем и потом убрать (или наоборот) — сдвиг вёрстки на её высоту,
// поэтому первый кадр рисуем по прошлому ответу сессии из localStorage.
// Промах возможен только при смене состояния между визитами и исправляется сам.
const STORAGE_KEY = "hero-try-free";

function readGuess() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === null ? true : stored === "true"; // без истории считаем гостем
  } catch {
    return true; // приватный режим / доступ к storage закрыт
  }
}

const showButtons = computed(() =>
  isSessionChecked.value ? props.isNew : readGuess(),
);

watch(
  () => [isSessionChecked.value, props.isNew],
  ([checked, isNew]) => {
    if (!checked) return;
    try {
      localStorage.setItem(STORAGE_KEY, String(isNew));
    } catch {
      // storage недоступен — просто не запоминаем
    }
  },
  { immediate: true },
);

const imgSrc = computed(() =>
  isDarkTheme.value
    ? "/pic/subscribe/hero/dark-w1770.jpg"
    : "/pic/subscribe/hero/light-w2360.jpg",
);
</script>

<style lang="scss" scoped>
@use "../../scss/variables" as *;

.hero-buttons {
  display: flex;
  justify-content: center;
  gap: 25px;
  padding: 38px 0 65px;
  margin: 0;
}

.pictures {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  // без этого ширина picture до загрузки схлопывается в 0, а после — прыгает
  // к размеру картинки; так бокс занимает всю ширину сразу
  picture {
    display: block;
    width: 100%;
  }

  img {
    max-width: 100%;
    width: 100%;
    border-radius: 26px;
    background: var(--body-color);
    overflow: hidden;
    aspect-ratio: auto;
    object-fit: cover;
    height: 570px;
  }
}

@media screen and (max-width: 1160px) {
  .pictures {
    img {
      border-radius: 16px;
      height: 370px;
    }
  }
}
@media screen and (max-width: 820px) {
  .pictures {
    img {
      border-radius: 16px;
      height: 270px;
    }
  }
}

@media screen and (max-width: $mobile) {
  .hero-buttons {
    flex-direction: column;
    gap: 10px;
    padding-left: 48px;
    padding-right: 48px;
  }

  .pictures {
    img {
      border-radius: 16px;
      height: 170px;
    }
  }
}
</style>
